import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import ProtectedRouter from "../Private/protectedRouter";
import LoginScreen from "../../components/Common/Login/login";
import forgotPwd from "../../components/Common/Login/forgotPwd";
import ResetPassword from "../../components/Common/Login/resetPassword";
import NotFound from "../../components/Common/NotFound/notFound";
import Dashboard from "../../components/Plan/BusinessUser/Dashboard/index";
import Risk from "../../components/Plan/BusinessUser/BURisks/index";
import Privacy from "../../components/Common/privacyPolicy";
import UserManagement from "../../components/Plan/BusinessUser/UserManagement/index";
import MasterRepository from "../../components/Plan/MasterRepository/index";
import Settings from "../../components/Plan/Settings/";
import VendorManagement from "../../components/Plan/vendorManagement/index";
import ManageUser from "../../components/Plan/ManageUsers";
import AuditHistory from "../../components/Plan/AuditHistory";
import WorkProgram from "../../components/Plan/AnalystWorkProgram";
import AnalystRisks from "../../components/Plan/AnalystRisks";
import Notifcations from "../../components/Plan/notification/notification.js";
import BusinessImpact from "../../components/Plan/BusinessUser/BusinessImpact";
import OrganizationScreen from "../../components/Common/Login/organizations";
import ViewThitdPartyRequests from "../../components/Plan/BusinessUser/UserManagement/ThirePartyRequest";
import Manager from "../../components/Plan/Manager/index";
import Analyst from "../../components/Plan/Analyst/index";
import EditPlan from "../../components/Plan/Analyst/EditPlan";
import ViewRisk from "../../components/Plan/Risks/index";
import UpdateRisk from "../../components/Plan/Risks/updateRisk";
import Vendor from "../../components/Plan/Vendor/index";
import AssessorInitiate from "../../components/Plan/Assessor/selfAssessment/InitiateSelf";
import OnSiteAssessment from "../../components/Plan/Assessor/OnSiteAssessment/OnsiteAssessments";
import AssessorWorkProgram from "../../components/Plan/Assessor/workProgram/WorkProgram";
import AssessorRiskManagement from "../../components/Plan/Assessor/riskManagement";
import RiskCreation from "../../components/Plan/Assessor/RiskCreate";
import AnalystIssueManagement from "../../components/Plan/AnalystIssueManagement";
import BIAEdit from "../../components/Plan/Assessor/BusinessImpactEdit";
import AssessorIssueManagement from "../../components/Plan/Assessor/issueManagement/IssueManagement";
import VendorIssueManagement from "../../components/Plan/Vendor/issueManagement/IssueManagement";
import ManagerRisks from "../../components/Plan/Manager/riskRequests/index";
import PwCIdentityRedirectEndpoint from "../../components/Common/Login/PwcIdentityRedirectEndpoint";
import VerifyIdamLogin from "../../components/Common/Login/VerifyIdamLogin";

function Routers() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={LoginScreen} />
        <Route path="/privacy" component={Privacy} />
        <Route path="/login" component={LoginScreen} />
        <Route
          path="/pwc-identity-redirect-endpoint"
          component={PwCIdentityRedirectEndpoint}
        />
        <Route
          path="/verify-idam-login/:email/:uniquecode"
          component={VerifyIdamLogin}
        />
        <Route exact path="/forgotpwd" component={forgotPwd} />
        <Route path="/resetpasssword/:id/:time/:randomNumber" component={ResetPassword} />
        <Route path="/organizations" exact={true} component={OrganizationScreen} />
        <ProtectedRouter path="/dashboard" exact={true}   component={Dashboard} />
   

        <ProtectedRouter
          path="/admin"
          exact={true}
          component={UserManagement}
        />
        <ProtectedRouter
          path="/masterRepository"
          exact={true}
          component={MasterRepository}
        />
        <ProtectedRouter path="/risk" exact={true} component={Risk} />
        <ProtectedRouter path="/settings" exact={true} component={Settings} />
        <ProtectedRouter
          path="/create-thirdpartyrequest"
          exact={true}
          component={VendorManagement}
        />
        <ProtectedRouter path="/users" exact={true} component={ManageUser} />
        <ProtectedRouter
          path="/auditHistory"
          exact={true}
          component={AuditHistory}
        />
        <ProtectedRouter
          path="/businessImpact"
          exact={true}
          component={BusinessImpact}
        />
        <ProtectedRouter
          path="/thirdpartyRequestManagement"
          exact={true}
          component={ViewThitdPartyRequests}
        />
        <ProtectedRouter path="/manager" exact={true} component={Manager} />
        <ProtectedRouter
          path="/notifications"
          exact={true}
          component={Notifcations}
        />
        <ProtectedRouter
          path="/manager/risk_management"
          exact={true}
          component={ManagerRisks}
        />
        <ProtectedRouter path="/analyst" exact={true} component={Analyst} />
        <ProtectedRouter path="/editPlan" exact={true} component={EditPlan} />
        <ProtectedRouter path="/viewRisk" exact={true} component={ViewRisk} />
        <ProtectedRouter
          path="/updateRisk"
          exact={true}
          component={UpdateRisk}
        />
        <ProtectedRouter
          path="/analystRisks"
          exact={true}
          component={AnalystRisks}
        />
        <ProtectedRouter
          path="/analystIssues"
          exact={true}
          component={AnalystIssueManagement}
        />
        <ProtectedRouter path="/vendor" exact={true} component={Vendor} />
        <ProtectedRouter
          path="/workProgram"
          exact={true}
          component={WorkProgram}
        />
        <ProtectedRouter
          path="/initiateAssessment"
          exact={true}
          component={AssessorInitiate}
        />
        <ProtectedRouter
          path="/onsiteAssessment"
          exact={true}
          component={OnSiteAssessment}
        />
        <ProtectedRouter
          path="/assessorWorkProgram"
          exact={true}
          component={AssessorWorkProgram}
        />
        <ProtectedRouter
          path="/riskManagement"
          exact={true}
          component={AssessorRiskManagement}
        />
        <ProtectedRouter
          path="/assessor/issue_management"
          exact={true}
          component={AssessorIssueManagement}
        />
        <ProtectedRouter
          path="/vendor/issue_management"
          exact={true}
          component={VendorIssueManagement}
        />
        <ProtectedRouter
          path="/riskCreation"
          exact={true}
          component={RiskCreation}
        />
        <ProtectedRouter path="/biaEdit" exact={true} component={BIAEdit} />
        <Route path="*" component={NotFound} />
      </Switch>
    </BrowserRouter>
  );
}

export default Routers;
